module.exports = "<div class=\"fixed-menu\">\r\n    <share-btn class=\"icon\" :item=\"shareBtnData\"></share-btn>\r\n<!--    <talk-btn class=\"icon\"></talk-btn>-->\r\n    <div class=\"icon icon-top\" v-show=\"isTopBtnShow\" @click=\"scrollToTop()\">\r\n        <i class=\"u-icon u-icon-top\"></i>\r\n    </div>\r\n    <div class=\"icon icon-top\" @click=\"scrollToBottom()\">\r\n        <i class=\"u-icon u-icon-bottom\"></i>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/phpStudy/PHPTutorial/WWW/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/menu/menu.html
// module id = 55
// module chunks = 0 1 2 3 4 5 6 7 8 9